import { render, staticRenderFns } from "./levelReport.vue?vue&type=template&id=3ac6f8f2&scoped=true"
import script from "./levelReport.vue?vue&type=script&lang=js"
export * from "./levelReport.vue?vue&type=script&lang=js"
import style0 from "./levelReport.vue?vue&type=style&index=0&id=3ac6f8f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac6f8f2",
  null
  
)

export default component.exports